.aside {
  width: var(--sidebar-w);
  flex: none;
  display: flex; flex-direction: column;
  background: var(--bg-elevated);
  border-right: 1px solid var(--border);
}
.controls {
  padding: 12px;
  display: flex; flex-direction: column; gap: 8px;
  border-bottom: 1px solid var(--border);
}

.dropdown { position: relative; }
.dropdownBtn {
  width: 100%;
  display: flex; align-items: center; justify-content: space-between;
  padding: 8px 12px;
  background: var(--bg-elevated-2);
  border: 1px solid var(--border-strong);
  border-radius: var(--r-sm);
  color: var(--text-primary);
  font-size: var(--fs-md);
}
.dropdownBtn:hover { border-color: var(--text-muted); }
.dropdownMenu {
  position: absolute; top: calc(100% + 4px); left: 0; right: 0;
  background: var(--bg-elevated-2);
  border: 1px solid var(--border-strong);
  border-radius: var(--r-sm);
  padding: 4px;
  z-index: 20;
  max-height: 320px;
  overflow: auto;
  box-shadow: var(--shadow-md);
}
.dropdownItem {
  display: flex; align-items: center; gap: 6px;
  width: 100%;
  padding: 7px 10px;
  border-radius: var(--r-xs);
  color: var(--text-primary);
  text-align: left;
  font-size: var(--fs-md);
}
.dropdownItem:hover { background: var(--bg-elevated); }
.dropdownItemActive { background: var(--accent-soft); color: var(--accent-hover); }

.searchWrap { position: relative; }
.searchIcon {
  position: absolute; left: 10px; top: 50%; transform: translateY(-50%);
  color: var(--text-muted);
}
.searchInput {
  width: 100%;
  padding: 8px 10px 8px 30px;
  background: var(--bg-elevated-2);
  border: 1px solid var(--border-strong);
  border-radius: var(--r-sm);
  color: var(--text-primary);
}
.searchInput:focus { outline: none; border-color: var(--accent); }

.list {
  flex: 1; overflow-y: auto; padding: 6px;
}
.row {
  position: relative;
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr) auto;
  align-items: center; gap: 10px;
  padding: 8px 10px 10px;
  border-radius: var(--r-sm);
  cursor: pointer;
  transition: background var(--dur-fast) var(--ease);
}
.row:hover { background: var(--bg-elevated-2); }
.rowActive {
  background: linear-gradient(90deg, var(--accent-soft) 0%, transparent 100%);
  box-shadow: inset 3px 0 0 var(--accent);
}
.logo {
  width: 40px; height: 40px;
  border-radius: var(--r-sm);
  background: var(--bg-elevated-2);
  display: flex; align-items: center; justify-content: center;
  overflow: hidden;
}
.logo img { width: 100%; height: 100%; object-fit: contain; }
.logoFallback { font-weight: 600; color: var(--text-secondary); font-size: var(--fs-sm); }
.meta { min-width: 0; }
.nameRow { display: flex; align-items: center; gap: 6px; min-width: 0; }
.name {
  flex: 1; min-width: 0;
  font-weight: 500;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.sub {
  font-size: var(--fs-xs);
  color: var(--text-secondary);
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  margin-top: 2px;
}
.subTime { color: var(--text-muted); font-variant-numeric: tabular-nums; }
.subTitle { color: var(--text-primary); }
.subMuted { color: var(--text-muted); font-style: italic; }
.rowActive .subTime { color: var(--accent-hover); }

.variants { display: flex; gap: 3px; flex: none; }
.variantPill {
  font-size: 9px; font-weight: 700; letter-spacing: 0.03em;
  padding: 2px 6px;
  border-radius: 999px;
  background: var(--bg-elevated-2);
  color: var(--text-muted);
  border: 1px solid var(--border);
  transition: background var(--dur-fast) var(--ease), color var(--dur-fast) var(--ease);
}
.variantPill:hover { color: var(--text-primary); }
.variantPillOn {
  background: var(--accent);
  color: #fff;
  border-color: var(--accent);
}

.progress {
  position: absolute;
  left: 12px; right: 12px; bottom: 4px;
  height: 2px;
  background: var(--border);
  border-radius: 1px;
  overflow: hidden;
  pointer-events: none;
}
.progressFill {
  height: 100%;
  /* Muted by default so the bar reads as a quiet indicator across the
     whole list — only the row currently playing gets the full accent. */
  background: color-mix(in oklab, var(--accent) 40%, transparent);
  transition: width 1s linear, background var(--dur-fast) var(--ease);
}
.row:hover .progressFill { background: color-mix(in oklab, var(--accent) 60%, transparent); }
.rowActive .progressFill { background: var(--accent-hover); }

.favBtn {
  width: 30px; height: 30px;
  display: flex; align-items: center; justify-content: center;
  border-radius: 50%;
  color: var(--text-muted);
  transition: background var(--dur-fast) var(--ease), color var(--dur-fast) var(--ease);
}
.favBtn:hover { background: var(--bg-elevated); color: var(--text-primary); }
.favOn { color: var(--danger); }

.loading { display: flex; justify-content: center; padding: 24px; color: var(--text-muted); }
.spin { animation: spin 1s linear infinite; }
@keyframes spin { from { transform: rotate(0); } to { transform: rotate(360deg); } }
.empty { text-align: center; color: var(--text-muted); padding: 30px 16px; font-size: var(--fs-sm); }
